import { msg } from '@lingui/macro';

/**
 * Brand sample-requests inbox (`/sample-requests`) — chunk A of the SR 2.0
 * migration from the post-2026-08-21 prototype.
 *
 * Index route only for now: the detail page is a later chunk, so no `:id` child
 * is registered yet (a route that renders nothing is worse than a 404).
 */
export const SampleRequestsRoutes = {
  path: 'sample-requests',
  async lazy() {
    const { Parent } = await import('../pages/sample-requests');
    return { Component: Parent };
  },
  handle: {
    name: 'Sample requests',
    category: 'Sample requests',
    title: msg`Sample requests`,
  },
  children: [
    {
      index: true,
      async lazy() {
        const { Index } = await import('../pages/sample-requests');
        return { Component: Index };
      },
    },
  ],
};
